<template>
  <div class="accordion" role="tablist">
    <div class="container">
      <h1 class="color-brand-4 tw-text-24px font-weight-light tw-uppercase mb-4 mt-5">Datele călătorilor</h1>

      <b-btn variant="link" @click="prevStep" class="btn btn-custom border-brand-4 color-brand-4 mb-5">< Pasul anterior</b-btn>

      <b-card class="border-white card-custom card-body-no-padding" v-for="(traveler, idx) in travelers" :key="idx" :set="v = $v.travelers.$each[idx]">
        <b-button variant="primary" role="tab" @click="switchToIndex(idx)"
                    class="btn text-decoration-none tw-text-hover md:tw-text-16px color-brand-3 tw-border-2 border-brand-3 color-brand-3 text-uppercase tw-font-medium my-3 hover:tw-text-white hover-bg-brand-3 btn-custom btn-primary">
            Călător {{
            idx + 1
            }}{{ (editedTravelerIdx !== idx) ? `: ${traveler.firstName} ${traveler.lastName}` : '' }}
            <i v-if="v.$error" style="font-size: 20px; color: orange;" class="fas fa-exclamation pt-1"></i>
        </b-button>
        <b-collapse :id="'accordion-'+idx" :visible="editedTravelerIdx === idx" accordion="my-accordion"
                    role="tabpanel">
          <b-card-body style="padding: 0 !important;">
            <b-row class="bg-light-custom rounded m-0">
                <b-col md="8" sm="12">
                    <b-row>
                        <b-col md="6" sm="12" class="form-group">
                            <input :id="'input_last_name[' + idx + ']'" type="text" class="form-control my-3"
                                   required ref="nume" :class="status(v.lastName)" v-model="traveler.lastName" disabled>
                            <label :for="'input_last_name[' + idx + ']'"
                                   v-if="traveler.lastName.length === 0" class="placeholder">Nume</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <input :id="'input_first_name[' + idx + ']'" type="text" class="form-control my-3" required
                                   ref="prenume" :class="status(v.firstName)" v-model="traveler.firstName" disabled>
                            <label :for="'input_first_name[' + idx + ']'"
                                   v-if="traveler.firstName.length === 0" class="placeholder">Prenume</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <select class="tw-border-third-gray hover:tw-border-green form-control rounded my-3" ref="id"
                                    v-model="traveler.idType" v-on:change="traveler.idNumber = ''">
                            <option value="CI">BI / CI</option>
                            <option value="PASAPORT">Pașaport</option>
                            </select>
                        </b-col>
                        <b-col md="3" sm="6" v-if="traveler.idType ==='CI'" class="form-group">
                            <input :id="'idSeries[' + idx + ']'" type="text" class="form-control my-3" maxlength="2"
                                   required ref="serie-buletin" :class="status(v.idSeries)" v-model="traveler.idSeries">
                            <label :for="'idSeries[' + idx + ']'"
                                   v-if="traveler.idSeries.length === 0" class="placeholder">Seria</label>
                        </b-col>
                        <b-col :md="traveler.idType === 'CI' ? 3 : 6" :sm="traveler.idType === 'CI' ? 3 : 6" class="form-group">
                            <input :id="'idNumber[' + idx + ']'" type="number" class="form-control my-3" required
                                   ref="numar-buletin" :class="status(v.idNumber)" v-model="traveler.idNumber">
                            <label :for="'idNumber[' + idx + ']'"
                                   v-if="traveler.idNumber.length === 0" class="placeholder">Numărul</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <input :id="'input_cnp[' + idx + ']'" type="text" class="form-control my-3" required
                                   ref="cnp" :class="status(v.cnp)" v-model="traveler.cnp" disabled>
                            <label :for="'input_cnp[' + idx + ']'"
                                   v-if="traveler.cnp.length === 0" class="placeholder">CNP</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <select :id="'select_county[' + idx + ']'" @change="getCities" ref="judet"
                                    class="tw-border-third-gray hover:tw-border-green form-control rounded my-3"
                                    v-model="traveler.county" :class="status(v.county)">
                            <option value="" disabled selected></option>
                            <option v-for="(county, key) in counties" :value="key">
                                {{ county }}
                            </option>
                            </select>
                            <label :for="'select_county[' + idx + ']'" :id="'label_county[' + idx + ']'"
                                   v-if="traveler.county.length === 0" class="placeholder">Județ</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <select :id="'select_city[' + idx + ']'" ref="oras"
                                    class="tw-border-third-gray hover:tw-border-green form-control rounded my-3"
                                    v-model="traveler.city" :class="status(v.city)" @change="setCityName(idx)">
                            <option value="" disabled selected></option>
                            <option v-for="(city) in traveler.cities" :value="city[0]">
                                {{ city[1] }}
                            </option>
                            </select>
                            <label :for="'select_city[' + idx + ']'" :id="'label_city[' + idx + ']'"
                                   v-if="traveler.city.length === 0" class="placeholder">Localitate</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <input :id="'input_street[' + idx + ']'" type="text" class="form-control my-3" required
                                   ref="strada" :class="status(v.street)" v-model="traveler.street">
                            <label :for="'input_street[' + idx + ']'"
                                   v-if="traveler.street.length === 0" class="placeholder">Strada</label>
                        </b-col>
                        <b-col md="3" sm="6" class="form-group">
                            <input :id="'input_number[' + idx + ']'" type="text" class="form-control my-3" required
                                   ref="numar" :class="status(v.number)" v-model="traveler.number">
                            <label :for="'input_number[' + idx + ']'"
                                   v-if="traveler.number.length === 0" class="placeholder">Numărul</label>
                        </b-col>
                        <b-col md="3" sm="6" class="form-group">
                            <input type="text" class="form-control my-3" placeholder="Bloc" ref="bloc"
                                :class="status(v.building)" v-model="traveler.building">
                        </b-col>
                        <b-col md="2" sm="4" class="form-group">
                            <input type="text" class="form-control my-3" placeholder="Scara" ref="scara"
                                :class="status(v.entry)" v-model="traveler.entry">
                        </b-col>
                        <b-col md="2" sm="4" class="form-group">
                            <input type="text" class="form-control my-3" placeholder="Etaj" ref="etaj"
                                :class="status(v.floor)" v-model="traveler.floor">
                        </b-col>
                        <b-col md="2" sm="4" class="form-group">
                            <input type="text" class="form-control my-3" placeholder="Apartament" ref="apartament"
                                :class="status(v.apartment)" v-model="traveler.apartment">
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <input :id="'input_email[' + idx + ']'" type="text" class="form-control my-3" required
                                   ref="email" :class="status(v.email)" v-model="traveler.email">
                            <label :for="'input_email[' + idx + ']'"
                                   v-if="traveler.email.length === 0" class="placeholder">Email</label>
                        </b-col>
                        <b-col md="6" sm="12" class="form-group">
                            <input :id="'input_phone[' + idx + ']'" type="text" class="form-control my-3" required
                                   ref="telefon" :class="status(v.phone)" v-model="traveler.phone">
                            <label :for="'input_phone[' + idx + ']'"
                                   v-if="traveler.phone.length === 0" class="placeholder">Telefon</label>
                        </b-col>
                    </b-row>
                </b-col>

                <b-col md="4" sm="12" class="p-0 m-0">
                    <CollectorData :collector="collector"></CollectorData>
                </b-col>
            </b-row>

          </b-card-body>
        </b-collapse>
        <hr class="hr-custom">
      </b-card>

      <b-row>
        <b-col class="p-3">
          <h3 class="tw-text-14px md:tw-text-16px tw-text-secondary-black tw-font-medium pt-4">
              Declar că la momentul incheierii acestei asigurări, toate persoanele asigurate de mai sus îndeplinesc
              următoarele condiții
          </h3>
          <ul class="tw-text-primary-gray md:tw-text-16px tw-text-14px tw-font-light mb-2 py-2 ul-custom">
            <li>se află pe teritoriul României</li>
            <li>nu călătoresc in scopul participării la curse sau competiții, inclusiv antrenamente, în calitate de
                sportiv profesionist
            </li>
            <li>nu urmează un tratament medical și nu urmează să înceapă un tratament pe perioada de asigurare</li>
            <li>nu suferă de boli cronice, incurabile sau afecțiuni pre-existente încheierii poliței</li>
            <li>nu consumă medicamente sau alte substanțe interzise în mod abuziv</li>
            <li>nu au invaliditate permanentă</li>
          </ul>
        </b-col>
      </b-row>

      <b-row class="py-4 px-3">
        <b-form-checkbox class="py-2" v-model="saveData">
          <h2 class="tw-text-14px md:tw-text-16px tw-text-secondary-black pb-2">
              Doresc salvarea datelor în contul meu pentru a le putea folosi cu ușurință la alte polițe sau la reînnoiri
          </h2>
        </b-form-checkbox>
      </b-row>

      <b-row class="py-4 px-3">
        <div class="bg-light-custom py-3 px-5">
          <h3 class="font-weight-bold mb-3">Info:</h3>
            Apăsând butonul de mai jos, declar că îmi asum deplina responsabilitate privind corectitudinea
            datelor/validitatea documentelor înregistrate în această secțiune.
        </div>
      </b-row>
      <b-row class="px-3">
        <b-btn variant="primary" class="py-2 px-4 mb-4 btn btn-primary bg-brand-1 hover-bg-brand-4 hover:tw-text-white hover-border-brand-4 btn-custom btn-custom-lg" @click="nextStep" :disabled="requestInProgress">
          <div v-if="requestInProgress">
            <b-spinner small></b-spinner>
            Se incarcă
          </div>
          <div v-else>Continuă</div>
        </b-btn>
      </b-row>

      <form :action="orderData.payment_url" ref="paymentForm" method="POST" id="payment_form">
        <input type="hidden" name="env_key" :value="orderData.env_key"/>
        <input type="hidden" name="data" :value="orderData.data"/>
      </form>
    </div>
  </div>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {alpha, alphaNum, email, numeric, required, requiredIf} from 'vuelidate/lib/validators';
import {cnp, idNumber, phone, series} from '../validations';
import {
  ADD_TRAVELER, COLLECT, FETCH_CITIES, FETCH_COUNTIES, ORDER,
  REMOVE_TRAVELER, SAVE_TRAVELERS, SET_SAVE_DATA
} from "../store/travel.module";
import {mapGetters} from "vuex";
import EventBus from '../eventbus';
import maxLength from "vuelidate/lib/validators/maxLength";
import CollectorData from "./CollectorData";

export default {
  name: "TravelPersonalData",
  metaInfo: {
    title: 'Datele calatorilor - Asigurare calatorie online - Fabrica de Asigurari',
  },
  data() {
    return {
      editedTravelerIdx: 0,
      requestInProgress: false
    }
  },
  computed: {
    ...mapGetters(['travelers', 'isLoggedIn', 'collector', 'counties', 'orderData', 'amountInsured']),
    saveData: {
      get() {
        return this.$store.getters.saveData
      },
      set(value) {
        this.$store.commit(SET_SAVE_DATA, value)
      }
    }
  },
  created() {
    this.initialize()
  },
  mounted() {
    this.$router.push('/asigurare-de-calatorie/datele-calatorilor').catch(()=>{});
    $('meta[name="description"]').attr('content','Completeaza toate datele calatorilor pentru a putea incheia politele de asigurare medicala de calatorie.');
    $('#idSeries').focus();
  },
  methods: {
    initialize() {
      this.$store.dispatch(FETCH_COUNTIES)
          .then(() => {
            for (let i = 0; i < this.travelers.length; i++) {
              this.$store.dispatch(FETCH_CITIES, {index: i, countyId: this.travelers[i].county})
                  .then(() => this.setCityName(i));
            }
          })
    },
    nextStep: function () {
      this.$v.$touch()
      if (this.$v.$invalid) {
        setTimeout(() => {
          for (let input in this.$refs) {
            if($(this.$refs[input][0]).hasClass('error')) {
              this.$refs[input][0].focus();
            }
          }
        }, 0);
      } else {

        this.requestInProgress = true;

        if (!this.isLoggedIn) {
          EventBus.$emit('next-step');
        } else {
          let promises = [this.$store.dispatch(ORDER, {travelers: this.travelers}), this.$store.dispatch(COLLECT, {nr_policies: this.travelers.length})];
          if (this.saveData) promises.push(this.$store.dispatch(SAVE_TRAVELERS, this.travelers));
          Promise.all(promises)
              .then(() => {
                this.$refs.paymentForm.submit();
                this.requestInProgress = false;
              })
              .catch(err => {
                console.log(err)
                this.requestInProgress = false;
              });
        }
      }
    },
    prevStep() {
      EventBus.$emit('prev-step');
    },
    status(validation) {
      if (!validation) return {};
      return {
        error: validation.$error,
        dirty: validation.$dirty
      }
    },
    switchToIndex(idx) {
      this.editedTravelerIdx = idx;
      this.$v.$touch();
    },
    getCities() {
      let index = this.editedTravelerIdx;
      this.$store.dispatch(FETCH_CITIES, {index: index, countyId: this.travelers[index].county})
          .then(() => this.setCityName(index));
    },
    setCityName(index) {
      for (let key in this.travelers[index].cities) {
        if (this.travelers[index].city === this.travelers[index].cities[key][0]) {
          this.travelers[index].cityName = this.travelers[index].cities[key][1];
        }
      }
    }
  },
  mixins: [validationMixin],
  validations() {
    return {
      travelers: {
        $each: {
          firstName: {
            required
          },
          lastName: {
            required
          },
          city: {
            required
          },
          county: {
            required
          },
          idType: {
            required
          },
          idSeries: {
            required: requiredIf((traveler) => {
              return traveler.idType === 'CI';
            }),
            series: series
          },
          idNumber: {
            required,
            numeric,
            idNumber: idNumber
          },
          street: {
            required
          },
          number: {
            required, pattern: /[0-9-]/
          },
          building: {
            pattern: /[0-9a-zA-Z-]/
          },
          entry: {
            pattern: /[0-9a-zA-Z-]/
          },
          floor: {
            pattern: /[0-9a-zA-Z-]/
          },
          apartment: {
            pattern: /[0-9-]/
          },
          email: {
            required, email
          },
          phone: {
            required,
            numeric,
            phone: phone
          },
          cnp: {
            required,
            cnp: cnp
          },
        }
      }
    }
  },
  components: {CollectorData}
}
</script>

<style scoped>
.error {
  border-color: orange;
  /*background: #FDD;*/
}

.error:focus {
  outline-color: #F99;
}

.form-group {
    margin-bottom: 0 !important;
    position: relative;
}

.form-group .placeholder {
    position: absolute;
    top: 30px;
    left: 28px;
    color: #a3a3a3;
    display: block;
    opacity: .6;
    cursor: text;
    user-select: none;
}

.form-group .placeholder:after {
    position: relative;
    top: -3px;
    left: 1px;
    display: inline-block;
    content: "*";
    color: #d0011b;
}

.form-control:focus + .placeholder {
    display: none;
}
</style>
